// extracted by mini-css-extract-plugin
export default {"user":"User_user__EaKM9","image":"User_image__PiVgD","icon":"User_icon__aMMB0"};